import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useI18n } from '../contexts/I18nContext';
import { UserCircle } from '@phosphor-icons/react';

export default function Team() {
  const { t } = useI18n();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get('/users')
      .then((r) => setUsers(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
  }, []);

  return (
    <div className="space-y-8">
      <header>
        <div className="text-xs uppercase tracking-[0.2em] text-sage-500 font-semibold mb-3">
          {t('nav_users')}
        </div>
        <h1 className="font-heading text-5xl text-ink leading-none">{t('users_title')}</h1>
        <p className="text-ink-soft mt-3 max-w-xl">{t('users_sub')}</p>
      </header>

      <div className="bg-white border border-stone_line rounded-2xl shadow-soft overflow-hidden">
        <ul className="divide-y divide-stone_line" data-testid="users-list">
          {users.map((u) => (
            <li key={u.id} className="flex items-center gap-4 px-6 py-4">
              <div className="w-10 h-10 rounded-full bg-sage-100 text-sage-600 grid place-items-center">
                <UserCircle size={22} weight="duotone" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-ink">{u.name}</div>
                <div className="text-xs text-ink-muted">{u.email}</div>
              </div>
              <div className="text-xs uppercase tracking-[0.18em] text-sage-600 bg-sage-100 px-3 py-1 rounded-full">
                {u.role}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
